export default __webpack_public_path__ + "static/media/Body Detection.321450da.jpg";